/* eslint-disable react-native/no-inline-styles */
import { Box, ColorOptions, Icon, Loader, ModBox, Spacer, SpacerNew, Text, TextNew } from '@jfs/ui-new'
import { FIELD_ERROR_STYLE, FIELD_LABEL_STYLE } from '../AdminInputs'
import { TextTypesOptions } from '@jfs/ui-new/src/comps/TextNew'
import { FC, useEffect, useRef, useState } from 'react'
import { GestureResponderEvent, TouchableOpacity, ViewStyle } from 'react-native'
import { ModalAlertView } from '../ModalAlertView'
import { ModalView } from './ModalView'

export interface DropdownProps {
  hide?: boolean
  selectedData?: (values: any) => void
  data: any
  title?: string
  error?: string
  errorColor?: ColorOptions
  touched?: boolean
  value?: any
  fieldName?: string
  setFieldValue?: (fieldName: string, value: string) => void
  isMultiSelect?: boolean
  label?: string
  labelType?: TextTypesOptions | Array<TextTypesOptions>
  minWidth?: any
  testID?: string
  fullWidthContent?: boolean
  transparentBorder?: boolean
  horizontalScroll?: boolean
  chevronColor?: ColorOptions
  separateDataAndDropdown?: boolean
  minHeight?: number
  textPaddingFromLeft?: number
  type?: 'default' | 'table'
  tableData?: any[]
  tableColumnMapper?: any
  tableHeaderTitles?: any[]
  onTableItemPress?: (data: any) => void
  passFullItemOnSelection?: boolean
  isDataLoading?: boolean
  dataFieldToRead?: string
  selectable?: boolean
  textWidth?: number | string
  additionalWidth?: number
  showResetSelection?: boolean
  labelColor?: ColorOptions
  showIcon?: boolean
  modalDetails?: any
  ignoreTouched?: boolean
}

const Dropdown: FC<DropdownProps> = ({
  hide,
  selectedData,
  data,
  fieldName,
  title,
  setFieldValue,
  touched,
  error,
  value,
  isMultiSelect = false,
  label,
  labelType = 'body14',
  minWidth,
  testID = '',
  fullWidthContent = false,
  chevronColor,
  transparentBorder = false,
  horizontalScroll = true,
  minHeight = 38,
  separateDataAndDropdown = false,
  textPaddingFromLeft,
  type = 'default',
  tableData = [],
  tableColumnMapper,
  tableHeaderTitles = [],
  onTableItemPress,
  passFullItemOnSelection = false,
  isDataLoading = false,
  dataFieldToRead = 'value',
  selectable = true,
  textWidth = '100%',
  additionalWidth,
  showResetSelection = false,
  labelColor = 'BRAND_COLOR_GRAY_1',
  showIcon = true,
  ignoreTouched = false,
  errorColor,
  modalDetails,
}: DropdownProps) => {
  const [showDropdown, setShowDropdown] = useState(false)

  const [measureInfo, setMeasureInfo] = useState({ left: 0, top: 0, width: 0 })
  let dopdownViewRef: any = useRef(null)

  const [buttonTitle, setButtonTitle] = useState(`${title}`)
  const [onShowDetails, setShowDetails] = useState(false)

  const getTitle = () => {
    const data = value && value?.split(',')
    let res = value && value !== '' ? data.join(', \n') : selectable ? `${title}` : ''
    res = !res && !selectable ? 'NA' : res
    return res
  }

  useEffect(() => {
    setButtonTitle(getTitle())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  if (hide) {
    return null
  }

  const dismissDropDown = () => {
    setShowDropdown(false)
  }

  const resetSelection = () => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, [''].join(','))
    }
    if (selectedData) {
      selectedData('')
      setButtonTitle('')
    }
  }

  const dropdownTapped = (evt: GestureResponderEvent): void => {
    if (evt) {
      const { x, y, height, width } = dopdownViewRef?.current?.getBoundingClientRect?.()
      setMeasureInfo({
        left: x,
        top: y + height + 20,
        width: additionalWidth && additionalWidth > 0 ? width + additionalWidth : width,
      })
      setShowDropdown((prev) => !prev)
    }
  }

  const onLayout = (event: any) => {
    if (dopdownViewRef) {
      const { x, y, height, width } = dopdownViewRef?.current?.getBoundingClientRect?.()
      setMeasureInfo({
        left: x,
        top: y + height + 20,
        width: additionalWidth && additionalWidth > 0 ? width + additionalWidth : width,
      })
    }
  }

  const onSelected = (item: any) => {
    if (setFieldValue && fieldName && item && !onTableItemPress) {
      setFieldValue(fieldName, item?.join(','))
    }
    if (selectedData && item) {
      selectedData(passFullItemOnSelection ? item : item?.join(','))
      setButtonTitle(passFullItemOnSelection ? item?.value : item?.join(','))
    }
    if (Array.isArray(item) && value !== item?.join(',')) {
      onTableItemPress?.(item?.join(','))
    }
  }

  const isPlaceholder = value === null || !value
  return (
    <Box>
      <Box flexDirection={'row'}>
        {label && (
          <Box>
            <TextNew {...FIELD_LABEL_STYLE} title={label} />
            <SpacerNew size={8} />
          </Box>
        )}
        {modalDetails?.data?.length > 0 && (
          <Box paddingLeft={6} underlayColor="TRANSPARENT" onPress={() => setShowDetails(true)}>
            <Icon id="INFO" size={16} color="ORANGE" />
          </Box>
        )}
        {modalDetails?.data?.length > 0 && onShowDetails && (
          <ModalAlertView
            show={true}
            title={label}
            buttonTitle=""
            message={modalDetails?.data?.replaceAll('|', '\n')}
            onDismiss={() => setShowDetails(false)}
            onCancel={() => setShowDetails(false)}
            height={500}
          />
        )}
      </Box>
      <TouchableOpacity
        activeOpacity={1}
        onPress={isDataLoading || !selectable ? undefined : dropdownTapped}
        ref={dopdownViewRef}
        style={[
          styles.containerStyle,
          {
            borderWidth: transparentBorder ? 0 : 1,
            shadowColor: transparentBorder ? 'transparent' : undefined,
            minWidth: minWidth ? minWidth : '100%', //Fix to occupy equal space when used in Form
            minHeight: minHeight,
            backgroundColor: transparentBorder ? 'TRANSPARENT' : 'white',
          },
        ]}
        onLayout={onLayout}>
        <Box
          testID={'dropdownTouchableID' + testID}
          onPress={isDataLoading || !selectable ? undefined : dropdownTapped}
          underlayColor="WHITE"
          flex={1}
          zIndex={99}
          width={textWidth}>
          <Box
            flexDirection="row"
            align="center"
            justify="space-between"
            f={1}
            w={'100%'}
            paddingLeft={textPaddingFromLeft ?? 14}
            paddingRight={8}>
            <TextNew
              type="body12"
              color={isPlaceholder ? ('#bfbfbf' as ColorOptions) : 'BLACK_21'}
              fontFamily="jiotype-medium"
              numberOfLines={1}>
              {buttonTitle}
            </TextNew>
            <ModBox show={isDataLoading}>
              <Loader color={'PRIMARY'} type={16} />
            </ModBox>
            <ModBox show={!isDataLoading && showIcon} direction="row" align="center">
              <Icon id={showDropdown ? 'ARROW_UP' : 'ARROW_DOWN'} size={18} color={chevronColor ?? 'BLACK_75'} />
              <ModBox
                show={showResetSelection}
                onPress={resetSelection}
                w={12}
                h={12}
                marginLeft={4}
                underlayColor={'GRAY_BORDER'}>
                <Icon id="CLEAR" size={12} color={chevronColor ?? 'BLACK_75'} />
              </ModBox>
            </ModBox>
          </Box>
        </Box>
        <ModalView
          hide={showDropdown}
          onDismiss={dismissDropDown}
          type={'multiselect'}
          data={data}
          selectedData={onSelected}
          measureInfo={measureInfo}
          preSelectedData={(value && value?.split(',')) ?? []}
          isMultiSelect={isMultiSelect}
          fullWidthContent={fullWidthContent}
          horizontalScroll={horizontalScroll}
          separateDataAndDropdown={separateDataAndDropdown}
          parentType={type}
          tableData={tableData}
          tableColumnMapper={tableColumnMapper}
          tableHeaderTitles={tableHeaderTitles}
          onTableItemPress={onTableItemPress}
          passFullItemOnSelection={passFullItemOnSelection}
          dataFieldToRead={dataFieldToRead}
        />
      </TouchableOpacity>
      {(touched || ignoreTouched) && !!error && selectable && (
        <>
          <Spacer size={2} />
          <TextNew testID={'textInputErrorId'} {...FIELD_ERROR_STYLE} color={errorColor ? errorColor : 'ERROR'}>
            {error}
          </TextNew>
        </>
      )}
    </Box>
  )
}

const shadow = {
  shadowColor: 'black',
  shadowOffset: {
    width: 0,
    height: 0.5,
  },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 2,
}

const styles = {
  containerStyle: {
    borderColor: '#d1d3e2' as ColorOptions,
    //backgroundColor: 'white',
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    borderRadius: 4,
    width: '100%',
    // ...shadow,
  } as ViewStyle,
}

export { Dropdown }
